import { render, staticRenderFns } from "./OperatorsManagement.vue?vue&type=template&id=4e4c5308&scoped=true"
import script from "./OperatorsManagement.vue?vue&type=script&lang=ts"
export * from "./OperatorsManagement.vue?vue&type=script&lang=ts"
import style0 from "./OperatorsManagement.vue?vue&type=style&index=0&id=4e4c5308&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4c5308",
  null
  
)

export default component.exports